import { Injectable } from '@angular/core';
import { GenericAction } from '@common-modules/redux/models/generic-action';
import { GenericExtendedSelector } from '@common-modules/redux/models/generic-extended-selector';
import { GenericSelector } from '@common-modules/redux/models/generic-selector';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { ReduxStateService } from '@common-modules/redux/redux-state.service';
import { Observable } from 'rxjs';
import { StateService } from './state.service';

@Injectable()
export class StateReduxImplService extends StateService {
  constructor(private _state: ReduxStateService) {
    super();
  }

  configure(settings: StateWidgetSettings): void {
    return this._state.configure(settings);
  }

  dispatch(action: GenericAction): void {
    return this._state.dispatch(action);
  }

  select<T>(selector: GenericSelector | GenericExtendedSelector): Observable<T> {
    return this._state.select(selector);
  }
}
